enum SearchValidationType {
    refDataSourceName = 'Ref Data Source Name',
    fieldName = 'Report Field Name',
    variableName = 'Variable Name',
    id = 'Id',
    name = 'Name'
}

export default SearchValidationType;
